import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../realize_overrides/components/modal/modal.jsx';

import { ModalActions } from '../../realize_overrides/stores/modal_store';
import { ProcessActions } from 'process/reflux/process_store';

const Realize = {
	i18n: window.Realize.i18n,
	Modal: Modal,
	ModalHeader: window.ModalHeader,
	ModalContent: window.ModalContent,
	ModalFooter: window.ModalFooter
};

export default class ProcessHelpModal extends React.Component {
	static propTypes = {
		modalId: PropTypes.string,
		description: PropTypes.string,
		helpText: PropTypes.string,
		isMobile: PropTypes.bool
	};

	static defaultProps = {
		modalId: 'help-modal',
		description: '-',
		helpText: '-',
		isMobile: false
	};

	getDescription() {
		return this.props.description;
	}

	getHelpText() {
		return this.props.helpText && (this.props.helpText || "").trim();
	}

	dismissModal() {
		ModalActions.close({ modalId: this.props.modalId });
	}

	downloadProcessHelpFile() {
		ProcessActions.downloadProcessHelpFile(null, null, { processId: this.props.processId, version: this.props.version });
	}

	renderDismissButton() {
		return (
			<Button
				name={Realize.i18n.t('actions.close')}
				element="a"
				icon="close"
				style="cancel"
				role='button'
				onClick={() => {
					this.dismissModal();
					setTimeout(() => { $('.openProcessHelpModal').focus() }, 200);
				}}
				className='btn-close-help-modal'
			/>
		);
	}

	renderDownloadProcessHelpFile() {
		return (
			<Button
				name={Realize.i18n.t(`process.helpFileDownload`)}
				element="a"
				icon="cloud_download"
				role='button'
				onClick={() => {
					this.downloadProcessHelpFile();
				}}
				className='btn-download-help-modal'
			/>
		);
	}

	tabOrder(){
		let btnClose = $('.btn-close-help-modal');
		btnClose.attr('tabindex', '0');

		btnClose.keydown(function(e) {
			if(e.which === 27 || e.keyCode === 27){
				$('.btn-close-help-modal')[0].click();
			}

			if(e.which === 13 || e.keyCode === 13){
				$('.btn-close-help-modal')[0].click();
			}
		});
	}

	componentDidMount(){
		setTimeout(() => { this.tabOrder() }, 100);
	}

	focusAutoComplete(modalId){
		if($(`#${modalId}`).is(':visible') === true){
			$(`#${modalId}_title`).focus();
			$(`#${modalId}`).find('a').attr('tabIndex', 0);
		}
	}

	render() {
		setTimeout(() => { this.focusAutoComplete(this.props.modalId)}, 1000);
		return (
			<Realize.Modal id={this.props.modalId} isMobile={this.props.isMobile} dismissible={false}>
				<Realize.ModalHeader>
					<span className="h5-custom" tabIndex="0" id={`${this.props.modalId}_title`}>
						{Realize.i18n.t('process.helpTitle')}
					</span>
				</Realize.ModalHeader>
				<Realize.ModalContent>
					<div className="process-help-modal__item" tabIndex="0">
						<span className="h5-custom">
							{Realize.i18n.t('process.helpDesc')}
						</span>
						<p>{this.getDescription() || Realize.i18n.t('process.helpDescEmpty')}</p>
					</div>

					<div className="process-help-modal__item" tabIndex="0">
						<span className="h5-custom">
							{Realize.i18n.t('process.helpTextModal')}
						</span>
						<p>{this.getHelpText() || Realize.i18n.t('process.helpTextEmpty')}</p>
					</div>

					<div tabIndex="0">
						<span className="h5-custom">
							{Realize.i18n.t(`process.helpFile`)}
						</span>
						{this.props.existHelpFile ? this.renderDownloadProcessHelpFile() : Realize.i18n.t(`process.helpFileEmpty`)}
					</div>
				</Realize.ModalContent>
				<Realize.ModalFooter className={'right-align'}>
					{this.renderDismissButton()}
				</Realize.ModalFooter>
			</Realize.Modal>
		);
	}
}
